export const EXP_TEMPLATE1 =
  "https://admin.dev.markedprivate.com/app/images/templates/experience_template1.png"
export const EXP_TEMPLATE2 =
  "https://admin.dev.markedprivate.com/app/images/templates/experience_template2.png"
export const EXP_TEMPLATE3 =
  "https://admin.dev.markedprivate.com/app/images/templates/experience_template3.png"
export const EXP_TEMPLATE4 =
  "https://admin.dev.markedprivate.com/app/images/templates/experience_template4.png"
export const EXP_TEMPLATE5 =
  "https://admin.dev.markedprivate.com/app/images/templates/experience_template5.png"
export const EXP_TEMPLATE6 =
  "https://admin.dev.markedprivate.com/app/images/templates/experience_template6.png"

export const STRIPE_BUTTON =
  "https://admin.dev.markedprivate.com/app/images/stripe_btn.png"

export const PROFILE_PLACEHOLDER =
  "https://admin.dev.markedprivate.com/app/images/profile_placeholder.jpg"
